import StatsRow from '@/AdminComponent/Reactions/components/Stats/StatsRow';
import React from 'react';

const StatsTable = ({ stats, groupBy, isLoading = false }) => {
	if (isLoading) return <p>Fetching data...</p>;
	const cellStyle = { padding: '0.5rem', border: '0.06rem solid #ccc' };
	return (
		<table style={{ borderCollapse: 'collapse', width: '100%', border: '0.06rem solid #ccc' }}>
			<thead>
				<tr style={{ backgroundColor: '#f2f2f2' }}>
					<th style={cellStyle}>Name</th>
					<th style={cellStyle}>Total Likes</th>
					<th style={cellStyle}>Total Dislikes</th>
					<th style={{ ...cellStyle, width: '3.13rem' }}></th>
				</tr>
			</thead>
			<tbody>
				{stats.map(group => (
					<StatsRow key={group.categoryId || group.instructorName || `Class Videos`} group={group} groupBy={groupBy} />
				))}
			</tbody>
		</table>
	);
};

export default StatsTable;
